import React, { useEffect, useState } from "react";
import classes from "./NewPayment.module.css";
import HeaderNav2 from "../../Components/Dahboard Header/HeaderNav/HeaderNav2";
import Footer from "../../Components/Footer/Footer";
import { useLocation } from "react-router-dom";
import { Trash2 } from "lucide-react";
import Select from "react-select";
import axios from "axios";
import swal from "sweetalert";
import { useNavigate } from "react-router-dom";
import { BASE_URL } from "../../Components/API/Api";
import {Row, Col} from 'react-bootstrap';



const NewPayment = () => {
  const [type, setType] = useState("products"); // "products" or "services"
  const [productOptions, setProductOptions] = useState([]);
  const [serviceOptions, setServiceOptions] = useState([]);
  const [products, setProducts] = useState([]);
  const [invoiceDate, setInvoiceDate] = useState("");
  const [dueDate, setDueDate] = useState("");
  const [invoiceCode, setInvoiceCode] = useState("");
  const [services, setServices] = useState([]);
  const [currencyOptions, setCurrencyOptions] = useState([]);
  const [selectedCurrency, setSelectedCurrency] = useState(null);
  const [customerOptions, setCustomerOptions] = useState([]);
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [taxOptions, setTaxOptions] = useState([]);
  const [currency, setCurrency] = useState("NGN");
  const navigate = useNavigate();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const formatMoney = (value) => {
    const raw = value.replace(/,/g, ''); // remove commas
    if (!raw) return '';
    const number = parseFloat(raw);
    if (isNaN(number)) return '';
    return number.toLocaleString();
  };
  const [invoiceItems, setInvoiceItems] = useState([
    {
      ledger: '',
      description: '',
      qty: 1,
      price: 0,
      discount: 0,
      vatRate: 'Premium',
      vat: 0,
      total: 0,
    }
  ]);
  const [loading, setLoading] = useState(true);

    useEffect(() => {
    const link = document.createElement("link");
    link.rel = "stylesheet";
    link.href = "https://cdn.jsdelivr.net/npm/bootstrap@5.3.3/dist/css/bootstrap.min.css";
    document.head.appendChild(link);
    return () => {
      document.head.removeChild(link);
    };
  }, []);

  useEffect(() => {
    const fetchTaxes = async () => {
      try {
        const token = localStorage.getItem("authToken");
        const res = await axios.get(`${BASE_URL}/v1/taxes/company-tax`, {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
          },
        });
        const options = Array.isArray(res.data.data)
          ? res.data.data.map((tax) => ({
            value: tax.id,
            label: `${tax.description} (${tax.rate}%)`,
            rate: tax.rate, // if available
          }))
          : [];
        setTaxOptions(options);
      } catch (err) {
        setTaxOptions([]);
      }
    };
    fetchTaxes();
  }, []);

  // useEffect(() => {
  //   const fetchInvoices = async () => {
  //     try {
  //       const token = localStorage.getItem("authToken");
  //       const res = await axios.post(`${BASE_URL}/v1/post-sales-invoice`, {
  //         headers: {
  //           Authorization: `Bearer ${token}`,
  //           Accept: "application/json",
  //         },
  //       });

  //       const data = res.data?.data || [];
  //       const formatted = data.map(item => ({
  //         ledger: item.ledger || '',
  //         description: item.description || '',
  //         qty: item.qty || 0,
  //         price: item.price || 0,
  //         discount: item.discount || 0,
  //         vatRate: item.vatRate || 'Premium',
  //         vat: item.vat || 0,
  //         total: item.total || 0,
  //       }));

  //       setInvoiceItems(formatted);
  //     } catch (error) {
  //       console.error("Error loading invoices:", error);
  //     } finally {
  //       setLoading(false);
  //     }
  //   };

  //   fetchInvoices();
  // }, []);


  // Fetch invoice code on mount
  useEffect(() => {
    const fetchInvoiceCode = async () => {
      try {
        const token = localStorage.getItem("authToken");
        const res = await axios.get(`${BASE_URL}/v1/generate-sales-invoice-code`, {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
          },
        });
        setInvoiceCode(res.data?.data?.toString() || "");
      } catch (err) {
        setInvoiceCode("");
      }
    };
    fetchInvoiceCode();
  }, []);

  // const handleChange = (index, field, value) => {
  //   const updatedItems = [...invoiceItems];
  //   const item = { ...updatedItems[index], [field]: field === 'ledger' || field === 'vatRate' || field === 'description' ? value : parseFloat(value) || 0 };

  //   const baseTotal = item.qty * item.price;
  //   const discount = item.discount || 0;
  //   const vatAmount = (baseTotal - discount) * 0.075;

  //   item.vat = vatAmount;
  //   item.total = baseTotal - discount + vatAmount;

  //   updatedItems[index] = item;
  //   setInvoiceItems(updatedItems);
  // };

  const handleAddRow = () => {
    setInvoiceItems(prev => [
      ...prev,
      {
        ledger: '',
        description: '',
        qty: 1,
        price: 0,
        discount: 0,
        vatRate: 'Premium',
        vat: 0,
        total: 0,
      }
    ]);
  };

  const handleDeleteRow = (index) => {
    const newItems = [...invoiceItems];
    newItems.splice(index, 1);
    setInvoiceItems(newItems);
  };

  // const handleSaveInvoice = async () => {
  //   try {
  //     const token = localStorage.getItem("authToken");
  //     await axios.post(`${BASE_URL}/api/v1/post-sales-invoice`, {
  //       invoice_data: invoiceItems,
  //       currency: currency,
  //     }, {
  //       headers: {
  //         Authorization: `Bearer ${token}`,
  //         Accept: "application/json",
  //         "Content-Type": "application/json",
  //       },
  //     });

  //     alert("Invoice saved successfully!");
  //   } catch (error) {
  //     console.error("Error saving invoice:", error);
  //     alert("Failed to save invoice");
  //   }
  // };

  const subtotal = invoiceItems.reduce((acc, item) => acc + item.qty * item.price, 0);
  const totalVAT = invoiceItems.reduce((acc, item) => acc + item.vat, 0);
  const grandTotal = invoiceItems.reduce((acc, item) => acc + item.total, 0);

  const location = useLocation();
  const pageMap = {
    "/dashboard": "Dashboard",
    "/transactions": "Transactions",
    "/accounts": "Accounting",
    "/reports": "Reports",
    "/banking": "Banking",
    "/settings": "Settings",
  };

  // Fetch products
  const fetchProducts = async () => {
    try {
      const token = localStorage.getItem("authToken");
      const res = await axios.get(`${BASE_URL}/v1/fetch_stocks`, {
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      });
      const options = Array.isArray(res.data.data)
        ? res.data.data.map((item) => ({
          value: item.id,
          label: item.name,
          price: item.unit_price,
        }))
        : [];
      setProductOptions(options);
    } catch (err) {
      setProductOptions([]);
    }
  };

  // Fetch services
  const fetchServices = async () => {
    try {
      const token = localStorage.getItem("authToken");
      const res = await axios.get(`${BASE_URL}/v1/items/fetch-services`, {
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      });
      const options = Array.isArray(res.data.data)
        ? res.data.data.map((item) => ({
          value: item.id,
          label: item.name,
          price: item.unit_price,
        }))
        : [];
      setServiceOptions(options);
    } catch (err) {
      setServiceOptions([]);
    }
  };

  // Fetch on type change
  useEffect(() => {
    if (type === "products") fetchProducts();
    else fetchServices();
  }, [type]);


  // Simulate fetching data (replace with real API calls)
  // const fetchProducts = async () => {
  // Replace with your API call
  //   setProducts([
  //     { name: "Product A", price: 100 },
  //     { name: "Product B", price: 200 },
  //   ]);
  // };
  // const fetchServices = async () => {
  // Replace with your API call
  //   setServices([
  //     { name: "Service A", price: 150 },
  //     { name: "Service B", price: 250 },
  //   ]);
  // };

  // Fetch data when type changes
  // React.useEffect(() => {
  //   if (type === "products") fetchProducts();
  //   else fetchServices();
  // }, [type]);

  // Fetch currencies for the Currency select
  useEffect(() => {
    const fetchCurrencies = async () => {
      try {
        const token = localStorage.getItem("authToken");
        const res = await axios.get(`${BASE_URL}/v1/fetch-all-currencies`, {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
          },
        });
        const options = Array.isArray(res.data.data)
          ? res.data.data.map((item) => ({
            value: item.id, // use only id
            label: item.name || item.code,
          }))
          : [];
        setCurrencyOptions(options);
      } catch (err) {
        setCurrencyOptions([]);
      }
    };
    fetchCurrencies();
  }, []);

  useEffect(() => {
    const fetchCustomers = async () => {
      try {
        const token = localStorage.getItem("authToken");
        const res = await axios.get(`${BASE_URL}/v1/beneficiary`, {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
          },
        });
        // Assuming response data is an array of currencies or customers
        const options = Array.isArray(res.data.data)
          ? res.data.data.map((item) => ({
            value: item.id || item.code || item.name,
            label: item.name || item.code,
          }))
          : [];
        setCustomerOptions(options);
      } catch (err) {
        setCustomerOptions([]);
      }
    };
    fetchCustomers();
  }, []);

  const handleChange = (index, field, value) => {
    const updatedItems = [...invoiceItems];
    let item = { ...updatedItems[index] };

    if (field === 'vatRate') {
      // If value is an object from react-select, extract id and rate
      item.vatRate = value;
    } else if (field === 'qty') {
      item.qty = Math.max(1, Number(value) || 1);
    } else if (field === 'price') {
      item.price = parseFloat(value) || 0;
    } else {
      item[field] = value;
    }

    // Find the selected tax rate if vatRate is set
    let taxRate = 0.075; // default 7.5%
    if (item.vatRateValue) {
      taxRate = parseFloat(item.vatRateValue) / 100;
    } else if (item.vatRate && item.vatRate.value) {
      const selectedTax = taxOptions.find(tax => tax.value === item.vatRate.value);
      if (selectedTax && selectedTax.rate) {
        taxRate = parseFloat(selectedTax.rate) / 100;
      }
    }

    const baseTotal = item.qty * item.price;
    const discount = item.discount || 0;
    const vatAmount = (baseTotal - discount) * taxRate;

    item.vat = vatAmount;
    item.total = baseTotal - discount + vatAmount;

    updatedItems[index] = item;
    setInvoiceItems(updatedItems);
  };


  const handleSaveInvoice = async () => {
    // Basic validation (optional, you can expand this)
    if (
      !type ||
      !selectedCustomer ||
      !invoiceCode ||
      !selectedCurrency ||
      !invoiceDate ||
      !dueDate ||
      invoiceItems.length === 0
    ) {
      swal("Error", "Please fill all required fields.", "error");
      return;
    }

    // Validate each item
    const hasInvalidItem = invoiceItems.some(
      item => !item.ledger || !item.qty || Number(item.qty) <= 0
    );
    if (hasInvalidItem) {
      swal("Error", "Each row must have a product/service and quantity greater than 0.", "error");
      return;
    }

    setIsSubmitting(true);

    // Calculate total amount and item amount
    const amount = invoiceItems.reduce((sum, item) => sum + Number(item.total), 0);
    // const item_amount = invoiceItems.reduce((sum, item) => sum + Number(item.price), 0);



    // Calculate arrays for item_id, quantity, and item_amount
    const item_id = invoiceItems.map(item => Number(item.ledger));
    const quantity = invoiceItems.map(item => Number(item.qty));
    const item_amount = invoiceItems.map(item => Number(item.total));
    // const item_id = invoiceItems.map(item => Number(item.ledger)).join(",");
    // const quantity = invoiceItems.map(item => Number(item.qty)).join(",");
    // const item_amount = invoiceItems.map(item => Number(item.total)).join(",");

    function cleanAmount(formattedAmount) {
      // Remove anything that's not a digit or decimal point
      return parseFloat(String(formattedAmount).replace(/[^0-9.]/g, '')) || 0;
    }

    // Clean each item's total
    const cleanedItems = invoiceItems.map(item => ({
      ...item,
      total: cleanAmount(item.total),
    }));

    // Prepare payload
    const payload = {
      option_type: type === "products" ? "product" : "service",
      description: invoiceItems.map(item => item.description).join(", "),
      invoice_number: invoiceCode,
      supplier_id: selectedCustomer.value,
      amount: cleanedItems.reduce((sum, item) => sum + item.total, 0),
      currency: selectedCurrency.value,
      transaction_date: invoiceDate,
      due_date: dueDate,
      item_id,         // <-- add this
      quantity,        // <-- add this
      item_amount,     // <-- add this

    };

    try {
      const token = localStorage.getItem("authToken");
      await axios.post(
        `${BASE_URL}/v1/make-purchase-invoice`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        }
      );
      swal("Success", "Invoice saved successfully!", "success")
        .then(() => {
          // 👇 Redirect and pass invoice details to new page
          navigate("/invoice-preview", {
            state: {
              invoiceNumber: invoiceCode,
              invoiceDate,
              dueDate,
              customer: selectedCustomer,
              items: invoiceItems,
              total: amount,
            },
          });
        });
      // Optionally, reset form here
    } catch (error) {
      if (error.response && error.response.data && error.response.data.message) {
        // Show backend validation errors
        swal("Error", JSON.stringify(error.response.data.message, null, 2), "error");
      } else {
        swal("Error", "Failed to save invoice", "error");
      }
    } finally {
      setIsSubmitting(false);
    }
  };


  return (
    <div>
      <HeaderNav2 className={classes.headerNavRoot} activePage={pageMap[location.pathname]} />
      <div className={classes.Container}>
        <header className={classes.Header}>
          <h2 className={classes.Title}>New Payment</h2>
          <h1 className={classes.Titles}>Manage all your payment.</h1>
        </header>

        <div className={classes.form}>
          <Row style={{ marginBottom: "15px" }}>
              <Col md={3}>
                <div className={classes.group}>
                  <label>Payment to</label>
                  <input
                    type="text"
                    value={invoiceDate}
                    onChange={e => setInvoiceDate(e.target.value)}
                    required
                    style={{ width: "100%" }}
                  />
                  {/* <Select
                    options={customerOptions}
                    value={selectedCustomer}
                    onChange={setSelectedCustomer}
                    placeholder="Choose customer"
                    isClearable
                    classNamePrefix="react-select"
                    required
                  /> */}
                </div>
              </Col>
              <Col md={3}>
                  <label style={{ width: "100%" }}>Transaction Date</label>
                  <input
                    type="date"
                    value={invoiceDate}
                    onChange={e => setInvoiceDate(e.target.value)}
                    required
                    style={{ width: "100%" }}
                  />
              </Col>
              <Col md={3}>
                  <label style={{ width: "100%" }}>Description</label>
                  <input
                    type="text"
                    value={dueDate}
                    onChange={e => setDueDate(e.target.value)}
                    required
                    style={{ width: "100%" }}
                  />
              </Col>
              <Col md={3}>
                  <label>Payment Mode</label>
                  <Select
                    options={currencyOptions}
                    value={selectedCurrency}
                    onChange={setSelectedCurrency}
                    placeholder="Choose currency"
                    isClearable
                    classNamePrefix="react-select"
                    required
                  />
              </Col>
          </Row>
          <Row>
              <Col md={3}>
                  <label>Currency</label>
                  <Select
                    options={currencyOptions}
                    value={selectedCurrency}
                    onChange={setSelectedCurrency}
                    placeholder="Choose currency"
                    isClearable
                    classNamePrefix="react-select"
                    required
                  />
              </Col>
              <Col md={3}>
                  <label style={{ width: "100%" }}>Teller/Cheque No.</label>
                  <input
                    type="text"
                    value={invoiceDate}
                    onChange={e => setInvoiceDate(e.target.value)}
                    required
                    style={{ width: "100%" }}
                  />
              </Col>
              <Col md={3}>
                  <label>Credit Account</label>
                  <Select
                    options={customerOptions}
                    value={selectedCustomer}
                    onChange={setSelectedCustomer}
                    placeholder="Choose customer"
                    isClearable
                    classNamePrefix="react-select"
                    required
                  />
              </Col>
              <Col md={3}>
                  <label>Amount</label>
                  <input
                    type="text"
                    value={invoiceDate}
                    onChange={e => setInvoiceDate(e.target.value)}
                    required
                    style={{ width: "100%" }}
                  />
              </Col>
          </Row>
        </div>

        <div className={classes.invoicecont}>
          {/* Toggle Buttons */}
          <div style={{ marginBottom: "1rem" }}>
            <button
              type="button"
              className={type === "products" ? classes.activeTab : classes.inactiveTab}
              onClick={() => setType("products")}
            >
              Products
            </button>
            <button
              type="button"
              className={type === "services" ? classes.activeTab : classes.inactiveTab}
              onClick={() => setType("services")}
            >
              Services
            </button>
          </div>
          <table className={classes.invoiceTable}>
            <thead>
              <tr>
                {/* <th><input type="checkbox" /></th> */}
                <th className={classes.productservice}>Product / Services</th>
                <th className={classes.deschdInput}>Description</th>
                <th className={classes.qtyhdInput}>Qty/Hrs*</th>
                <th className={classes.priceRateCol}>Price/Rate*</th>
                <th className={classes.qtyhdInput}>Discount</th>
                <th className={classes.qtyhdInput}>VAT/Rate*</th>
                <th>VAT*</th>
                <th>Total</th>
                <th className={classes.plushd}>
                  <button type="button" className={classes.addRowBtn} onClick={handleAddRow}>+</button>
                </th>
              </tr>
            </thead>
            <tbody>
              {invoiceItems.length === 0 ? (
                <tr><td colSpan="10">{type === "products" ? (
                  <div>
                    {products.length === 0 ? "Loading products..." : (
                      <ul>
                        {products.map((p, i) => (
                          <li key={i}>{p.name} - ₦{p.price}</li>
                        ))}
                      </ul>
                    )}
                  </div>
                ) : (
                  <div>
                    {services.length === 0 ? "Loading services..." : (
                      <ul>
                        {services.map((s, i) => (
                          <li key={i}>{s.name} - ₦{s.price}</li>
                        ))}
                      </ul>
                    )}
                  </div>
                )}
                </td></tr>
              ) : (
                invoiceItems.map((item, index) => (
                  <tr key={index}>
                    {/* <td><input type="checkbox" /></td> */}
                    <td>
                      <Select
                        options={type === "products" ? productOptions : serviceOptions}
                        value={
                          (type === "products"
                            ? productOptions
                            : serviceOptions
                          ).find(opt => opt.value === item.ledger) || null
                        }
                        onChange={selected => {
                          const updatedItems = [...invoiceItems];
                          if (selected) {
                            updatedItems[index] = {
                              ...updatedItems[index],
                              ledger: selected.value,
                              description: selected.label,
                              price: selected.price || 0,
                              // Optionally reset qty, discount, vatRate, etc. if needed
                            };
                          } else {
                            updatedItems[index] = {
                              ...updatedItems[index],
                              ledger: '',
                              description: '',
                              price: 0,
                            };
                          }
                          setInvoiceItems(updatedItems);
                          
                          // Recalculate totals after price change
                          if (selected) {
                            const item = updatedItems[index];
                            const baseTotal = item.qty * item.price;
                            const discount = item.discount || 0;
                            const vatAmount = (baseTotal - discount) * 0.075; // Default VAT rate
                            item.vat = vatAmount;
                            item.total = baseTotal - discount + vatAmount;
                            setInvoiceItems([...updatedItems]);
                          }
                        }}
                        placeholder={`Select ${type === "products" ? "product" : "service"}`}
                        isClearable
                        classNamePrefix={`"react-select" ${classes.productSelect}`}
                        className={classes.productSelect}
                      />
                    </td>
                    <td>
                      <input
                        type="text"
                        value={item.description}
                        className={classes.descriptionInput}
                        onChange={(e) => handleChange(index, 'description', e.target.value)}
                      />
                    </td>
                    <td>
                      <input
                        type="number"
                        min={1}
                        className={classes.qtyInput}
                        value={item.qty}
                        onChange={(e) => handleChange(index, 'qty', e.target.value)}
                      />
                    </td>
                    <td>
                      <input
                        type="text"
                        className={classes.priceRateInput}
                        value={formatMoney(item.price?.toString() || "")}
                        onChange={(e) => { const cleaned = e.target.value.replace(/,/g, ''); handleChange(index, 'price', cleaned) }}
                        disabled
                      />
                    </td>
                    <td>
                      <input
                        type="number"
                        value={item.discount}
                        className={classes.dscntInput}
                        onChange={(e) => handleChange(index, 'discount', e.target.value)}
                      />
                    </td>
                    <td>
                      <Select
                        options={taxOptions}
                        className={classes.vatInput}
                        value={taxOptions.find(opt => opt.value === item.vatRate) || null}
                        onChange={selected => {
                          // Update vatRate and optionally the vat amount if you want
                          handleChange(index, 'vatRate', selected);
                          // Optionally, update VAT calculation here if you want to use selected.rate
                        }}
                        placeholder="VAT/Rate"
                        isClearable
                        classNamePrefix="react-select"
                      />
                    </td>
                    <td>
                      <input className={classes.vatttInput} type="text" value={formatMoney(item.vat.toFixed(2))} readOnly />
                    </td>
                    <td>
                      <input className={classes.vatttInput} type="text" value={formatMoney(item.total.toFixed(2))} readOnly />
                    </td>
                    <td>
                      <Trash2
                        size={16}
                        onClick={() => handleDeleteRow(index)}
                        className={classes.deleteIcon}
                      />
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>

          <div className={classes.paginationContainer}>
            <div className={classes.paginationControls}>
              <button>First</button>
              <button className={classes.active}>1</button>
              <button>2</button>
              <button>Last</button>
              <span className={classes.pageText}>Displaying 1 - {invoiceItems.length} of {invoiceItems.length}</span>
            </div>
          </div>


        </div>

        <div className={classes.foot}>
          <div className={classes.Footer}>
            <div className={`${classes.footerSection} ${classes.comments}`}>
              <label>Comments</label>
              <textarea className={classes.commentsBox}></textarea>
            </div>

            <div className={`${classes.footerSection} ${classes.policies}`}>
              <label>Policies and guidelines</label>
              <textarea className={classes.policiesBox}></textarea>
            </div>

            <div className={`${classes.footerSection} ${classes.summary}`}>
              <div className={classes.totals}>
                <div className={classes.totalRow}>
                  <span>Subtotal:</span>
                  <span>₦{formatMoney(subtotal.toFixed(2))}</span>
                </div>
                <div className={classes.totalRow}>
                  <span>VAT (7.5%):</span>
                  <span>₦{formatMoney(totalVAT.toFixed(2))}</span>
                </div>
                <div className={`${classes.totalRow} ${classes.total}`}>
                  <span>Total:</span>
                  <strong>₦{formatMoney(grandTotal.toFixed(2))}</strong>
                </div>
              </div>

              <div className={classes.actionButtons}>
                <button className={classes.cancelButton}>Cancel</button>
                <button
                  className={classes.saveButton}
                  onClick={handleSaveInvoice}
                  type="button"
                  disabled={isSubmitting}
                >
                  {isSubmitting ? "Saving..." : "Save Payment"}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default NewPayment;
